import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreOrganizationsUnlinkPostAsyncSlice } from './post';

export const coreOrganizationsUnlinkReducers = combineReducers({
	post: coreOrganizationsUnlinkPostAsyncSlice.asyncReducers
});

export const coreOrganizationsUnlinkWatchers = combineAllWatchers([
	coreOrganizationsUnlinkPostAsyncSlice.asyncWatchers
]);
